<div class="container-fluid si-dashboard">
  @if (loading) {
    <div class="si-dashboard__loading">
      <span class="spinner-border text-primary" role="status"></span>
    </div>
  } @else if (error) {
    <div class="alert alert-danger mt-3">{{ error | translate }}</div>
  } @else if (definition) {
    <div class="si-dashboard__header">
      <h1 class="si-dashboard__title">{{ definition.name | translate }}</h1>
      <div class="si-dashboard__actions">
        @if (refreshError) {
          <span class="si-dashboard__error">{{ refreshError | translate }}</span>
        }
        @if (actionError) {
          <span class="si-dashboard__error">{{ actionError | translate }}</span>
        }
        @if (status?.computedAt) {
          <span class="si-dashboard__updated" [title]="(status?.computedAt | date: 'yyyy-MM-dd HH:mm') ?? ''">
            {{ 'SALES_INSIGHTS_UPDATED' | translate }} {{ status?.computedAt | date: updatedFormat }}
          </span>
        }
        @for (action of pageActions; track action.action) {
          <button type="button" class="btn si-dashboard__action" [disabled]="isRunning(action)" (click)="runAction(action)">
            @if (action.icon) {
              <i [class]="action.icon" [class.fa-spin]="isRunning(action) && action.action === 'refresh'"></i>
            }
            {{ action.labelKey | translate }}
            @if (isRunning(action) && action.action !== 'refresh') {
              <span class="spinner-border spinner-border-sm" role="status"></span>
            }
          </button>
        }
      </div>
    </div>

    <lib-sales-insights-filter-bar [filters]="definition.filters"></lib-sales-insights-filter-bar>

    @for (section of definition.sections; track $index; let sectionIndex = $index) {
      <section class="si-section">
        @if (section.title) {
          <div class="si-section__header">
            <span class="si-section__number">{{ $index + 1 }}</span>
            <h2 class="si-section__title">{{ section.title | translate }}</h2>
          </div>
        }
        @if (isTabs(section)) {
          <nav ngbNav #nav="ngbNav" class="nav-tabs si-tabs" [(activeId)]="activeTabs[sectionIndex]">
            @for (component of section.components; track $index; let tabIndex = $index) {
              <ng-container [ngbNavItem]="tabIndex">
                <button type="button" ngbNavLink>{{ (component.title || component.type) | translate }}</button>
                <ng-template ngbNavContent>
                  <ng-container *ngTemplateOutlet="componentTemplate; context: { $implicit: component }"></ng-container>
                </ng-template>
              </ng-container>
            }
          </nav>
          <div class="si-tabs__content" [ngbNavOutlet]="nav"></div>
        } @else {
          <div class="row g-3">
            @for (component of section.components; track $index) {
              <div [class]="columnClasses(component)">
                <ng-container *ngTemplateOutlet="componentTemplate; context: { $implicit: component }"></ng-container>
              </div>
            }
          </div>
        }
      </section>
    }
  }
</div>

<ng-template #componentTemplate let-component>
  @if (component.error) {
    <lib-sales-insights-card [cardTitle]="component.title" [error]="component.error"></lib-sales-insights-card>
  } @else if (componentFor(component); as componentType) {
    <ng-container *ngComponentOutlet="componentType; inputs: { config: component }"></ng-container>
  } @else {
    <lib-sales-insights-card
      [cardTitle]="component.title"
      [error]="('SALES_INSIGHTS_UNKNOWN_TYPE' | translate) + ': ' + component.type"
    ></lib-sales-insights-card>
  }
</ng-template>
